'use client'
import PrivacyPolicy from 'components/documents/privacy-policy'
import {Suspense} from 'react'
import {MIXPANEL_ATTRIBUTES, MIXPANEL_KEYS} from 'analytics/mixpanel'
import {useTrackEvent} from 'hooks/use-track-event'

const page2 = () => {
  return (
    <Suspense>
      <Page />
    </Suspense>
  )
}

const Page = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useTrackEvent(MIXPANEL_KEYS.PRIVACY_POLICY, [MIXPANEL_ATTRIBUTES.SOURCE])
  return <PrivacyPolicy />
}

export default page2
